import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { UtilsService } from 'src/app/core/services/utils/utils.service';
import { PendingOrdersService } from 'src/app/core/services/pending-orders/pending-orders.service';
import { OIOTAC } from 'src/app/models/oi-ot-ac.model';
import { Router } from '@angular/router';
import { PopoverController, ActionSheetController, ModalController, Platform } from '@ionic/angular';
import { OrderDetailsPopoverComponent } from '../order-details-popover/order-details-popover.component';
import { RESPONSE_TYPE, ORDER_TYPE, ORDER_STATUS_IDS, REQUEST_STATUS_IDS, REQUEST_STATUS_NAMES } from 'src/app/models/enums'

@Component({
  selector: 'cc-pending',
  templateUrl: './pending.component.html',
  styleUrls: ['./pending.component.scss'],
})
export class PendingComponent implements OnInit {

  @Input() pending: OIOTAC;
  @Input() unit;
  @Input() isOnline: boolean = false;
  @Input() timeResponseConfig: number = 0;
  @Output() finishedAction = new EventEmitter<any>();

  private params;
  public isDisabled: boolean = false;
  public showAll: boolean = true;
  public responsesTypes = RESPONSE_TYPE;
  public showCardFooter: boolean = false;
  public timeResponseDate: Date = null;
  public showTimeResponseDate: boolean = false;
  public requestStatusIds = REQUEST_STATUS_IDS;
  public requestStatusNames;
  public culture = 'es-CL';

  constructor(
    private pendingsService: PendingOrdersService,
    private utils: UtilsService,
    private router: Router,
    public popoverController: PopoverController,
    private actShCtlr: ActionSheetController,
    private modalCtrl: ModalController,
    private translate: TranslateService,
    public platform: Platform
  ) { }

  async ngOnInit() {
    this.culture = await this.utils.getCulture();
    this.params = {
      company: this.pending.empresa.id, selectedUnitId: this.pending.unidad.id,
      requestId: this.pending.solicitud.id
    }

    this.pending.fecha_edicion = this.utils.changeDateSeparator(this.pending.fecha_edicion);
    if (this.pending.fecha_inicio && this.pending.fecha_fin) {
      this.pending.fecha_inicio = this.utils.changeDateSeparator(this.pending.fecha_inicio);
      this.pending.fecha_fin = this.utils.changeDateSeparator(this.pending.fecha_fin);

      this.pending.dias = this.utils.getDaysBetweenDates(this.pending.fecha_inicio);
      this.pending.diff_days = this.utils.getDaysBetweenDates(this.pending.fecha_inicio, this.pending.fecha_fin);
    }

    this.showAll = ((this.pending.estado && this.pending.estado.id === 1) || this.pending.tipo === 'AC') ? true : false;

    this.requestStatusNames = this.translate.instant(`enum.${REQUEST_STATUS_NAMES[this.pending.solicitud.estado_id]}`);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.timeResponseConfig.currentValue >= 0)
      this.shouldShowCardFooter();
  }

  handleUserResponse(resp) {
    if (this.isOnline) {
      if (resp === RESPONSE_TYPE.CANCEL) {
        this.confirmation(this.pending.tipo, RESPONSE_TYPE.CANCEL);
      } else {
        if (resp) {
          this.sendResponse(resp)
        } else {
          this.confirmation(this.pending.tipo, RESPONSE_TYPE.REJECT);
        }
      }
    } else {
      this.utils.showMessage(this.translate.instant('pending.Sin conexión a internet'));
    }
  }

  sendResponse(resp) {
    this.isDisabled = true;
    const fd = new FormData();
    fd.append('confirmacion', resp);

    if (this.pending.tipo === 'OI') {
      this.pendingsService.confirmOI({ ...this.params, oiId: this.pending.id }, fd)
        .subscribe(data => {
          this.manageResponse(data, { type: 'oi', answer: resp });
        });
    } else {
      this.pendingsService.confirmOT({ ...this.params, otId: this.pending.id }, fd)
        .subscribe(data => {
          this.manageResponse(data, { type: 'ot', answer: resp });
        });
    }
  }

  cancel() {
    this.isDisabled = true;
    if (this.pending.tipo === 'OI') {
      this.pendingsService.cancelOI({ ...this.params, oiId: this.pending.id })
        .subscribe(data => {
          this.manageResponse(data, { type: 'oi', answer: this.translate.instant('pending.cancelada') });
        });
    } else {
      this.pendingsService.cancelOT({ ...this.params, otId: this.pending.id })
        .subscribe(data => {
          this.manageResponse(data, { type: 'ot', answer: this.translate.instant('pending.cancelada') });
        });
    }
  }

  manageResponse({ data, error, operation }, answer) {
    this.isDisabled = false;
    if (error) {
      if (error.status === 403)
        this.utils.showMessage(error.error.message)
      else
        this.utils.showMessage(operation)
    } else {
      this.showAll = false;
      this.pending.estado.nombre = isNaN(answer.answer) ? this.translate.instant('pending.cancelada') : answer.answer ? this.translate.instant('pending.confirmada') : this.translate.instant('pending.rechazada');
      this.pending.estado.id = isNaN(answer.answer) ? 4 : answer.answer ? 2 : 3;
      // this.utils.showMessage(`Orden de ${answer.type === 'oi' ? 'inspección' : 'trabajo'} ${isNaN(answer.answer) ?
      //   'cancelada' : answer.answer ? 'confirmada' : 'rechazada'}`);
    }
  }


  async seeDetails() {
    const popover = await this.popoverController.create({
      component: OrderDetailsPopoverComponent,
      componentProps: { details: this.pending.detalles },
      translucent: true,
      cssClass: 'custom-popover'
    });
    return await popover.present();
  }

  async goToConformity() {
    if (this.isOnline) {
      const isModalOpen = await this.modalCtrl.getTop();
      if (isModalOpen)
        await this.modalCtrl.dismiss();
      await this.utils.saveInStorage('unitParams', {
        company: this.pending.empresa.id, selectedUnitId: this.pending.unidad.id, companyName: this.pending.empresa.nombre, inCharge: this.pending.solicitud.responsable ? this.pending.solicitud.responsable.nombre : null
      });
      await this.utils.saveInStorage('requestInfo', { id: this.pending.solicitud.id, subject: '' });
      this.router.navigate(['/conformity']);
    } else {
      this.utils.showMessage(this.translate.instant('pending.Sin conexión a internet'));
    }
  }

  async confirmation(orderType, responseType) {
    const actionSheet = await this.actShCtlr.create({
      buttons: [{
        role: 'destructive',
        text: `${responseType === RESPONSE_TYPE.REJECT ? this.translate.instant('pending.Rechazar')
          : this.translate.instant('pending.Cancelar')} ${orderType === ORDER_TYPE.OI
            ? this.translate.instant('pending.visita de inspección') : this.translate.instant('pending.agenda de trabajos')}`,
        handler: () => {
          if (responseType === RESPONSE_TYPE.REJECT)
            this.sendResponse(RESPONSE_TYPE.REJECT);
          else
            this.cancel();
        }
      }, {
        text: this.translate.instant('pending.Volver'),
        role: 'cancel',
      }]
    });
    await actionSheet.present();
  }

  shouldShowCardFooter() {
    if (this.pending.tipo === ORDER_TYPE.AC || this.pending.tipo === ORDER_TYPE.OT)
      this.showCardFooter = true;
    else if (this.pending.tipo === ORDER_TYPE.OI && (this.pending.estado && (this.pending.estado.id !== ORDER_STATUS_IDS.REJECTED && this.pending.estado.id !== ORDER_STATUS_IDS.CANCELED)))
      this.showCardFooter = true;
    else
      this.showCardFooter = false;

    if (this.pending.tipo === ORDER_TYPE.OT || this.pending.tipo === ORDER_TYPE.OI) {
      let beginDate = new Date(this.pending.fecha_inicio);
      this.timeResponseDate = new Date();
      this.timeResponseDate.setTime(beginDate.getTime() - this.pending.timeResponseConfig * 60 * 1000);
      if (new Date() > this.timeResponseDate && (this.pending.estado && this.pending.estado.id === ORDER_STATUS_IDS.PENDING))
        this.showTimeResponseDate = true;
      else
        this.showTimeResponseDate = false;
    }
  }

}
